import { memo, useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useFreshRef } from 'src/lib/hooks';

import { FormCanvas } from '../../components/FormCanvas';
import { useDataContextValue } from '../../context';

import { useStyles } from './useStyles';

const DEFAULT_VALUE = {};

export const ContentCanvas = memo(
  ({ className, value, onChange, onFieldFocus, onFieldBlur, errors, disabled }) => {
    const styles = useStyles();
    const { viewMode, generationTool, limitMultilineMaxRows } = useDataContextValue();

    const valueRef = useFreshRef(value);

    const handleFieldChange = useCallback(
      (field, fieldValue) => {
        const newValue = {
          ...valueRef.current,
          [field]: fieldValue,
        };
        onChange(newValue, field);
      },
      [onChange, valueRef]
    );

    return (
      <div
        className={cx(styles.root, className)}
        data-view-mode={viewMode}
        data-testid="ContentCanvas"
      >
        <FormCanvas
          generationTool={generationTool}
          content={value || DEFAULT_VALUE}
          onFieldChange={handleFieldChange}
          onFieldFocus={onFieldFocus}
          onFieldBlur={onFieldBlur}
          errors={errors}
          disabled={disabled}
          limitMultilineMaxRows={limitMultilineMaxRows}
        />
      </div>
    );
  }
);

ContentCanvas.propTypes = {
  className: PropTypes.string,
  value: PropTypes.shape(),
  onChange: PropTypes.func.isRequired,
  onFieldFocus: PropTypes.func,
  onFieldBlur: PropTypes.func,
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};
ContentCanvas.defaultProps = {
  className: null,
  value: null,
  onFieldFocus: null,
  onFieldBlur: null,
  errors: null,
  disabled: false,
};
